/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAnnounce = /* GraphQL */ `query GetAnnounce($id: String!) {
  getAnnounce(id: $id) {
    body
    createdAt
    expiredAt
    id
    level
    owner
    subject
    to
    updatedAt
    ym
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAnnounceQueryVariables,
  APITypes.GetAnnounceQuery
>;
export const getAtomicCounter = /* GraphQL */ `query GetAtomicCounter($counterName: String!) {
  getAtomicCounter(counterName: $counterName) {
    counterName
    createdAt
    kind
    sequence
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAtomicCounterQueryVariables,
  APITypes.GetAtomicCounterQuery
>;
export const getBatchJobConf = /* GraphQL */ `query GetBatchJobConf($jobName: String!) {
  getBatchJobConf(jobName: $jobName) {
    allowedGroups
    createdAt
    jobName
    remarks
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBatchJobConfQueryVariables,
  APITypes.GetBatchJobConfQuery
>;
export const getBuildPrice = /* GraphQL */ `query GetBuildPrice($year: Int!) {
  getBuildPrice(year: $year) {
    createdAt
    owner
    unitPriceCB
    unitPriceOther
    unitPriceRC
    unitPriceS
    unitPriceSRC
    unitPriceW
    updatedAt
    year
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBuildPriceQueryVariables,
  APITypes.GetBuildPriceQuery
>;
export const getCognitoUserF = /* GraphQL */ `query GetCognitoUserF($username: String) {
  getCognitoUserF(username: $username) {
    errorMessage
    item {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCognitoUserFQueryVariables,
  APITypes.GetCognitoUserFQuery
>;
export const getCompany = /* GraphQL */ `query GetCompany($id: String!, $infoName: String!) {
  getCompany(id: $id, infoName: $infoName) {
    address
    areaNames
    areaPrefs
    areas
    bldConditionCompanies
    bldConditionSelections
    branchAddress
    branchFax
    branchId
    branchName
    branchTel
    branchUrl
    createdAt
    eAreaNames
    eAreas
    email
    estateTypes
    fax
    guaranter
    id
    infoName
    job
    latitude
    license
    licenseCount
    licenseNo
    licenser
    logoImg
    longitude
    name
    organization
    owner
    recNo
    remarks
    remarks2
    searchInfo
    startMark
    tel
    updatedAt
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyQueryVariables,
  APITypes.GetCompanyQuery
>;
export const getCompanyForAnonymousF = /* GraphQL */ `query GetCompanyForAnonymousF($id: String!) {
  getCompanyForAnonymousF(id: $id) {
    organization
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCompanyForAnonymousFQueryVariables,
  APITypes.GetCompanyForAnonymousFQuery
>;
export const getDummy = /* GraphQL */ `query GetDummy($id: String!) {
  getDummy(id: $id) {
    createdAt
    id
    kintoneAppScope
    kintoneDataKind
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetDummyQueryVariables, APITypes.GetDummyQuery>;
export const getEstate = /* GraphQL */ `query GetEstate($id: String!, $infoName: String!) {
  getEstate(id: $id, infoName: $infoName) {
    address
    appearanceImgs
    area
    balconyArea
    bcr
    bldConditionType
    buildingCompany
    buildingFloors
    cadastralMapPdf
    carsInParkingN
    city
    cityPlanningType
    cleaningMonth
    clearingType
    collectedAt
    companyAddress
    companyBranchId
    companyFax
    companyGuaranter
    companyId
    companyLicense
    companyName
    companyRecNo
    companyTel
    companyUrl
    completionMonth
    completionMonthS
    completionSchMonth
    condominiumId
    condominiumName
    condominiumRecNo
    confirmed
    createdAt
    currentStatus
    currentStatusB
    currentStatusFree
    currentStatusG
    deletedOnSumora
    drivewayPay
    eSchool
    estatePrice
    estateType
    estateUrl
    exactLocation
    floor
    floorAreaRatio
    floorStructure
    fullAddress
    gas
    gasPdf
    groundPdf
    groundType
    groundTypeFree
    id
    infoName
    isLot
    jSchool
    landAreaType
    landRights
    latitude
    layout
    layoutImgs
    license
    location
    longitude
    managementFee
    managementType
    manager
    mapImg
    media
    mediationKind
    name
    nearlyLocation
    notFoundAt
    otherCost
    owner
    parking
    parkingFee
    parkingHeight
    parkingMechOrPlane
    parkingTakeOver
    parkingTakeOverFree
    pet
    prefecture
    priceHistory {
      price
      pricedAt
      __typename
    }
    pricedAt
    purposeB
    purposeSummaryB
    recNo
    remarks
    repairCost
    roadDirection
    roadType
    roadWidth
    room
    searchInfo
    seller
    sewer
    sewerPdf
    sold
    squareArea
    status
    store
    structure
    structureFree
    subCompany2Address
    subCompany2Fax
    subCompany2Guaranter
    subCompany2Id
    subCompany2License
    subCompany2Name
    subCompany2Tel
    subCompany2Url
    subCompanyAddress
    subCompanyFax
    subCompanyGuaranter
    subCompanyId
    subCompanyLicense
    subCompanyName
    subCompanyRecNo
    subCompanyTel
    subCompanyUrl
    tileOnZoom12
    tileOnZoom14
    tileOnZoom16
    totalArea
    totalHouses
    traffic
    tsuboArea
    unitPrice
    unsettledLocation
    updatedAt
    url
    useDistrict
    water
    waterPdf
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEstateQueryVariables, APITypes.GetEstateQuery>;
export const getKintoneData = /* GraphQL */ `query GetKintoneData($appScopeAndRecNo: String!, $kind: String!) {
  getKintoneData(appScopeAndRecNo: $appScopeAndRecNo, kind: $kind) {
    appScope
    appScopeAndRecNo
    createdAt
    estateUrl
    kind
    mansionName
    recNo
    record
    scrapeeBaseUrl
    sortKey
    sortKeyForStatus
    status
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetKintoneDataQueryVariables,
  APITypes.GetKintoneDataQuery
>;
export const getPresignedUrlForAnonymousF = /* GraphQL */ `query GetPresignedUrlForAnonymousF($key: String) {
  getPresignedUrlForAnonymousF(key: $key) {
    errorMessage
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPresignedUrlForAnonymousFQueryVariables,
  APITypes.GetPresignedUrlForAnonymousFQuery
>;
export const getPresignedUrlForDeleteF = /* GraphQL */ `query GetPresignedUrlForDeleteF(
  $companyId: String
  $estateId: String
  $key: String
) {
  getPresignedUrlForDeleteF(
    companyId: $companyId
    estateId: $estateId
    key: $key
  ) {
    errorMessage
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPresignedUrlForDeleteFQueryVariables,
  APITypes.GetPresignedUrlForDeleteFQuery
>;
export const getPresignedUrlForGetF = /* GraphQL */ `query GetPresignedUrlForGetF(
  $companyId: String
  $estateId: String
  $key: String
) {
  getPresignedUrlForGetF(
    companyId: $companyId
    estateId: $estateId
    key: $key
  ) {
    errorMessage
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPresignedUrlForGetFQueryVariables,
  APITypes.GetPresignedUrlForGetFQuery
>;
export const getPresignedUrlForPutF = /* GraphQL */ `query GetPresignedUrlForPutF(
  $companyId: String
  $estateId: String
  $key: String
) {
  getPresignedUrlForPutF(
    companyId: $companyId
    estateId: $estateId
    key: $key
  ) {
    errorMessage
    url
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPresignedUrlForPutFQueryVariables,
  APITypes.GetPresignedUrlForPutFQuery
>;
export const getPublicEstate = /* GraphQL */ `query GetPublicEstate($id: String!) {
  getPublicEstate(id: $id) {
    createdAt
    distributer {
      address
      areaNames
      areaPrefs
      areas
      bldConditionCompanies
      bldConditionSelections
      branchAddress
      branchFax
      branchId
      branchName
      branchTel
      branchUrl
      createdAt
      eAreaNames
      eAreas
      email
      estateTypes
      fax
      guaranter
      id
      infoName
      job
      latitude
      license
      licenseCount
      licenseNo
      licenser
      logoImg
      longitude
      name
      organization
      owner
      recNo
      remarks
      remarks2
      searchInfo
      startMark
      tel
      updatedAt
      url
      __typename
    }
    estate {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    estateId
    expiredAt
    id
    tel
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPublicEstateQueryVariables,
  APITypes.GetPublicEstateQuery
>;
export const getReport = /* GraphQL */ `query GetReport($id: ID!) {
  getReport(id: $id) {
    companyId
    companyName
    createdAt
    description
    estateId
    estateName
    expiredAt
    id
    latitude
    longitude
    owner
    reportKind
    updatedAt
    userName
    __typename
  }
}
` as GeneratedQuery<APITypes.GetReportQueryVariables, APITypes.GetReportQuery>;
export const getStickyNote = /* GraphQL */ `query GetStickyNote($id: String!, $infoName: String!) {
  getStickyNote(id: $id, infoName: $infoName) {
    color
    companyId
    createdAt
    description
    icon
    id
    infoName
    latitude
    longitude
    memoKind
    openLevel
    owner
    searchInfo
    tileOnZoom12
    tileOnZoom14
    tileOnZoom16
    updatedAt
    url1
    url2
    url3
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStickyNoteQueryVariables,
  APITypes.GetStickyNoteQuery
>;
export const getUser = /* GraphQL */ `query GetUser($infoName: String!, $username: String!) {
  getUser(infoName: $infoName, username: $username) {
    agreement
    authenticatedAt
    companyBranchName
    companyId
    companyName
    createdAt
    defaultCondition {
      alsoCreatedAtFrom
      alsoCreatedAtTo
      alsoPricedAtFrom
      alsoPricedAtTo
      areaPrefs
      areas
      bldConditionSelections
      companyRecNo
      completionYMFrom
      completionYMTo
      estatePriceFrom
      estatePriceTo
      estateTypes
      exceptForRent
      flat
      forRent
      petOk
      priceLabel
      purposeSummaryBs
      roomsFrom
      roomsTo
      squareAreaOfMansionFrom
      squareAreaOfMansionTo
      structureSummaries
      tsuboAreaFrom
      tsuboAreaTo
      tsuboLabel
      venderOnly
      __typename
    }
    email
    group
    infoName
    name
    nameRuby
    owner
    paid
    pricingAvailable
    role
    searchInfo
    tel
    trial
    trialEndAt
    updatedAt
    username
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listAnnounces = /* GraphQL */ `query ListAnnounces(
  $filter: ModelAnnounceFilterInputInput
  $id: String
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAnnounces(
    filter: $filter
    id: $id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      body
      createdAt
      expiredAt
      id
      level
      owner
      subject
      to
      updatedAt
      ym
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnnouncesQueryVariables,
  APITypes.ListAnnouncesQuery
>;
export const listAnnouncesByYm = /* GraphQL */ `query ListAnnouncesByYm(
  $filter: ModelAnnounceFilterInputInput
  $limit: Int
  $nextToken: String
  $sortDirection: ListAnnouncesByYmSortDirection
  $to: CustomModelStringKeyConditionInputInput
  $ym: String!
) {
  listAnnouncesByYm(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    to: $to
    ym: $ym
  ) {
    items {
      body
      createdAt
      expiredAt
      id
      level
      owner
      subject
      to
      updatedAt
      ym
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAnnouncesByYmQueryVariables,
  APITypes.ListAnnouncesByYmQuery
>;
export const listAtomicCounters = /* GraphQL */ `query ListAtomicCounters(
  $counterName: String
  $filter: ModelAtomicCounterFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listAtomicCounters(
    counterName: $counterName
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      counterName
      createdAt
      kind
      sequence
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAtomicCountersQueryVariables,
  APITypes.ListAtomicCountersQuery
>;
export const listBatchJobConfs = /* GraphQL */ `query ListBatchJobConfs(
  $filter: ModelBatchJobConfFilterInput
  $jobName: String
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBatchJobConfs(
    filter: $filter
    jobName: $jobName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      allowedGroups
      createdAt
      jobName
      remarks
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBatchJobConfsQueryVariables,
  APITypes.ListBatchJobConfsQuery
>;
export const listBatchJobs = /* GraphQL */ `query ListBatchJobs(
  $filter: ModelBatchJobFilterInput
  $id: ID
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBatchJobs(
    filter: $filter
    id: $id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      expiredAt
      id
      jobName
      remarks
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBatchJobsQueryVariables,
  APITypes.ListBatchJobsQuery
>;
export const listBatchJobsByJobName = /* GraphQL */ `query ListBatchJobsByJobName(
  $createdAt: ModelStringKeyConditionInput
  $filter: ModelBatchJobFilterInput
  $jobName: String!
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listBatchJobsByJobName(
    createdAt: $createdAt
    filter: $filter
    jobName: $jobName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      expiredAt
      id
      jobName
      remarks
      status
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBatchJobsByJobNameQueryVariables,
  APITypes.ListBatchJobsByJobNameQuery
>;
export const listBuildPrices = /* GraphQL */ `query ListBuildPrices(
  $filter: ModelBuildPriceFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $year: Int
) {
  listBuildPrices(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    year: $year
  ) {
    items {
      createdAt
      owner
      unitPriceCB
      unitPriceOther
      unitPriceRC
      unitPriceS
      unitPriceSRC
      unitPriceW
      updatedAt
      year
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBuildPricesQueryVariables,
  APITypes.ListBuildPricesQuery
>;
export const listCognitoUsersF = /* GraphQL */ `query ListCognitoUsersF(
  $companyIds: [String]
  $email: AWSEmail
  $groups: [String]
  $name: String
  $nameRuby: String
  $nextToken: String
  $paid: Boolean
  $pricingAvailable: Boolean
  $trial: Boolean
  $username: String
) {
  listCognitoUsersF(
    companyIds: $companyIds
    email: $email
    groups: $groups
    name: $name
    nameRuby: $nameRuby
    nextToken: $nextToken
    paid: $paid
    pricingAvailable: $pricingAvailable
    trial: $trial
    username: $username
  ) {
    errorMessage
    items {
      Attributes {
        Name
        Value
        __typename
      }
      Company {
        address
        areaNames
        areaPrefs
        areas
        bldConditionCompanies
        bldConditionSelections
        branchAddress
        branchFax
        branchId
        branchName
        branchTel
        branchUrl
        createdAt
        eAreaNames
        eAreas
        email
        estateTypes
        fax
        guaranter
        id
        infoName
        job
        latitude
        license
        licenseCount
        licenseNo
        licenser
        logoImg
        longitude
        name
        organization
        owner
        recNo
        remarks
        remarks2
        searchInfo
        startMark
        tel
        updatedAt
        url
        __typename
      }
      Enabled
      Groups {
        CreationDate
        Description
        GroupName
        LastModifiedDate
        Precedence
        RoleArn
        UserPoolId
        __typename
      }
      MFAOptions {
        AttributeName
        DeliveryMedium
        __typename
      }
      User {
        agreement
        authenticatedAt
        companyBranchName
        companyId
        companyName
        createdAt
        defaultCondition {
          alsoCreatedAtFrom
          alsoCreatedAtTo
          alsoPricedAtFrom
          alsoPricedAtTo
          areaPrefs
          areas
          bldConditionSelections
          companyRecNo
          completionYMFrom
          completionYMTo
          estatePriceFrom
          estatePriceTo
          estateTypes
          exceptForRent
          flat
          forRent
          petOk
          priceLabel
          purposeSummaryBs
          roomsFrom
          roomsTo
          squareAreaOfMansionFrom
          squareAreaOfMansionTo
          structureSummaries
          tsuboAreaFrom
          tsuboAreaTo
          tsuboLabel
          venderOnly
          __typename
        }
        email
        group
        infoName
        name
        nameRuby
        owner
        paid
        pricingAvailable
        role
        searchInfo
        tel
        trial
        trialEndAt
        updatedAt
        username
        __typename
      }
      UserCreateDate
      UserLastModifiedDate
      UserStatus
      Username
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCognitoUsersFQueryVariables,
  APITypes.ListCognitoUsersFQuery
>;
export const listCompanies = /* GraphQL */ `query ListCompanies(
  $filter: ModelCompanyFilterInputInput
  $id: String
  $infoName: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listCompanies(
    filter: $filter
    id: $id
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      areaNames
      areaPrefs
      areas
      bldConditionCompanies
      bldConditionSelections
      branchAddress
      branchFax
      branchId
      branchName
      branchTel
      branchUrl
      createdAt
      eAreaNames
      eAreas
      email
      estateTypes
      fax
      guaranter
      id
      infoName
      job
      latitude
      license
      licenseCount
      licenseNo
      licenser
      logoImg
      longitude
      name
      organization
      owner
      recNo
      remarks
      remarks2
      searchInfo
      startMark
      tel
      updatedAt
      url
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesQueryVariables,
  APITypes.ListCompaniesQuery
>;
export const listCompaniesBySearchInfo = /* GraphQL */ `query ListCompaniesBySearchInfo(
  $filter: ModelCompanyFilterInputInput
  $infoName: String!
  $limit: Int
  $nextToken: String
  $searchInfo: CustomModelStringKeyConditionInputInput
  $sortDirection: ListCompaniesBySearchInfoSortDirection
) {
  listCompaniesBySearchInfo(
    filter: $filter
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    searchInfo: $searchInfo
    sortDirection: $sortDirection
  ) {
    items {
      address
      areaNames
      areaPrefs
      areas
      bldConditionCompanies
      bldConditionSelections
      branchAddress
      branchFax
      branchId
      branchName
      branchTel
      branchUrl
      createdAt
      eAreaNames
      eAreas
      email
      estateTypes
      fax
      guaranter
      id
      infoName
      job
      latitude
      license
      licenseCount
      licenseNo
      licenser
      logoImg
      longitude
      name
      organization
      owner
      recNo
      remarks
      remarks2
      searchInfo
      startMark
      tel
      updatedAt
      url
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCompaniesBySearchInfoQueryVariables,
  APITypes.ListCompaniesBySearchInfoQuery
>;
export const listDummies = /* GraphQL */ `query ListDummies(
  $filter: ModelDummyFilterInput
  $id: String
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listDummies(
    filter: $filter
    id: $id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      createdAt
      id
      kintoneAppScope
      kintoneDataKind
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDummiesQueryVariables,
  APITypes.ListDummiesQuery
>;
export const listEstates = /* GraphQL */ `query ListEstates(
  $filter: ModelEstateFilterInputInput
  $id: String
  $infoName: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listEstates(
    filter: $filter
    id: $id
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEstatesQueryVariables,
  APITypes.ListEstatesQuery
>;
export const listEstatesBySearchInfo = /* GraphQL */ `query ListEstatesBySearchInfo(
  $filter: ModelEstateFilterInputInput
  $infoName: String!
  $limit: Int
  $nextToken: String
  $searchInfo: CustomModelStringKeyConditionInputInput
  $sortDirection: ListEstatesBySearchInfoSortDirection
) {
  listEstatesBySearchInfo(
    filter: $filter
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    searchInfo: $searchInfo
    sortDirection: $sortDirection
  ) {
    items {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEstatesBySearchInfoQueryVariables,
  APITypes.ListEstatesBySearchInfoQuery
>;
export const listEstatesForPricingF = /* GraphQL */ `query ListEstatesForPricingF(
  $estateTypes: [String]!
  $points: [PointForPricingInputInput]!
  $tileOnZoom16s: [String]!
) {
  listEstatesForPricingF(
    estateTypes: $estateTypes
    points: $points
    tileOnZoom16s: $tileOnZoom16s
  ) {
    items {
      address
      appearanceImgs
      area
      balconyArea
      bcr
      bldConditionType
      buildingCompany
      buildingFloors
      cadastralMapPdf
      carsInParkingN
      city
      cityPlanningType
      cleaningMonth
      clearingType
      collectedAt
      companyAddress
      companyBranchId
      companyFax
      companyGuaranter
      companyId
      companyLicense
      companyName
      companyRecNo
      companyTel
      companyUrl
      completionMonth
      completionMonthS
      completionSchMonth
      condominiumId
      condominiumName
      condominiumRecNo
      confirmed
      createdAt
      currentStatus
      currentStatusB
      currentStatusFree
      currentStatusG
      deletedOnSumora
      drivewayPay
      eSchool
      estatePrice
      estateType
      estateUrl
      exactLocation
      floor
      floorAreaRatio
      floorStructure
      fullAddress
      gas
      gasPdf
      groundPdf
      groundType
      groundTypeFree
      id
      infoName
      isLot
      jSchool
      landAreaType
      landRights
      latitude
      layout
      layoutImgs
      license
      location
      longitude
      managementFee
      managementType
      manager
      mapImg
      media
      mediationKind
      name
      nearlyLocation
      notFoundAt
      otherCost
      owner
      parking
      parkingFee
      parkingHeight
      parkingMechOrPlane
      parkingTakeOver
      parkingTakeOverFree
      pet
      prefecture
      priceHistory {
        price
        pricedAt
        __typename
      }
      pricedAt
      purposeB
      purposeSummaryB
      recNo
      remarks
      repairCost
      roadDirection
      roadType
      roadWidth
      room
      searchInfo
      seller
      sewer
      sewerPdf
      sold
      squareArea
      status
      store
      structure
      structureFree
      subCompany2Address
      subCompany2Fax
      subCompany2Guaranter
      subCompany2Id
      subCompany2License
      subCompany2Name
      subCompany2Tel
      subCompany2Url
      subCompanyAddress
      subCompanyFax
      subCompanyGuaranter
      subCompanyId
      subCompanyLicense
      subCompanyName
      subCompanyRecNo
      subCompanyTel
      subCompanyUrl
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      totalArea
      totalHouses
      traffic
      tsuboArea
      unitPrice
      unsettledLocation
      updatedAt
      url
      useDistrict
      water
      waterPdf
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEstatesForPricingFQueryVariables,
  APITypes.ListEstatesForPricingFQuery
>;
export const listReports = /* GraphQL */ `query ListReports(
  $filter: ModelReportFilterInput
  $id: ID
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listReports(
    filter: $filter
    id: $id
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      companyId
      companyName
      createdAt
      description
      estateId
      estateName
      expiredAt
      id
      latitude
      longitude
      owner
      reportKind
      updatedAt
      userName
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListReportsQueryVariables,
  APITypes.ListReportsQuery
>;
export const listScrapings = /* GraphQL */ `query ListScrapings(
  $baseUrl: String
  $filter: ModelScrapingFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $sortKey: ModelStringKeyConditionInput
) {
  listScrapings(
    baseUrl: $baseUrl
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    sortKey: $sortKey
  ) {
    items {
      baseUrl
      createdAt
      endedAt
      input
      operation
      output
      prefName
      remarks
      resultKey
      sortKey
      startedAt
      status
      totalCount
      updated {
        blocked
        expired
        newRecord
        onSite
        requiresAuth
        return
        returnAndUpdatePrice
        scrapingFailed
        updateFailed
        updatePrice
        __typename
      }
      updatedAt
      updating {
        blocked
        expired
        newRecord
        onSite
        requiresAuth
        return
        returnAndUpdatePrice
        scrapingFailed
        updateFailed
        updatePrice
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScrapingsQueryVariables,
  APITypes.ListScrapingsQuery
>;
export const listStickyNotes = /* GraphQL */ `query ListStickyNotes(
  $filter: ModelStickyNoteFilterInputInput
  $id: String
  $infoName: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listStickyNotes(
    filter: $filter
    id: $id
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      color
      companyId
      createdAt
      description
      icon
      id
      infoName
      latitude
      longitude
      memoKind
      openLevel
      owner
      searchInfo
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      updatedAt
      url1
      url2
      url3
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStickyNotesQueryVariables,
  APITypes.ListStickyNotesQuery
>;
export const listStickyNotesBySearchInfo = /* GraphQL */ `query ListStickyNotesBySearchInfo(
  $filter: ModelStickyNoteFilterInputInput
  $infoName: String!
  $limit: Int
  $nextToken: String
  $searchInfo: CustomModelStringKeyConditionInputInput
  $sortDirection: ListStickyNotesBySearchInfoSortDirection
) {
  listStickyNotesBySearchInfo(
    filter: $filter
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    searchInfo: $searchInfo
    sortDirection: $sortDirection
  ) {
    items {
      color
      companyId
      createdAt
      description
      icon
      id
      infoName
      latitude
      longitude
      memoKind
      openLevel
      owner
      searchInfo
      tileOnZoom12
      tileOnZoom14
      tileOnZoom16
      updatedAt
      url1
      url2
      url3
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStickyNotesBySearchInfoQueryVariables,
  APITypes.ListStickyNotesBySearchInfoQuery
>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInputInput
  $infoName: ModelStringKeyConditionInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
  $username: String
) {
  listUsers(
    filter: $filter
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
    username: $username
  ) {
    items {
      agreement
      authenticatedAt
      companyBranchName
      companyId
      companyName
      createdAt
      defaultCondition {
        alsoCreatedAtFrom
        alsoCreatedAtTo
        alsoPricedAtFrom
        alsoPricedAtTo
        areaPrefs
        areas
        bldConditionSelections
        companyRecNo
        completionYMFrom
        completionYMTo
        estatePriceFrom
        estatePriceTo
        estateTypes
        exceptForRent
        flat
        forRent
        petOk
        priceLabel
        purposeSummaryBs
        roomsFrom
        roomsTo
        squareAreaOfMansionFrom
        squareAreaOfMansionTo
        structureSummaries
        tsuboAreaFrom
        tsuboAreaTo
        tsuboLabel
        venderOnly
        __typename
      }
      email
      group
      infoName
      name
      nameRuby
      owner
      paid
      pricingAvailable
      role
      searchInfo
      tel
      trial
      trialEndAt
      updatedAt
      username
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const listUsersBySearchInfo = /* GraphQL */ `query ListUsersBySearchInfo(
  $filter: ModelUserFilterInputInput
  $infoName: String!
  $limit: Int
  $nextToken: String
  $searchInfo: CustomModelStringKeyConditionInputInput
  $sortDirection: ListUsersBySearchInfoSortDirection
) {
  listUsersBySearchInfo(
    filter: $filter
    infoName: $infoName
    limit: $limit
    nextToken: $nextToken
    searchInfo: $searchInfo
    sortDirection: $sortDirection
  ) {
    items {
      agreement
      authenticatedAt
      companyBranchName
      companyId
      companyName
      createdAt
      defaultCondition {
        alsoCreatedAtFrom
        alsoCreatedAtTo
        alsoPricedAtFrom
        alsoPricedAtTo
        areaPrefs
        areas
        bldConditionSelections
        companyRecNo
        completionYMFrom
        completionYMTo
        estatePriceFrom
        estatePriceTo
        estateTypes
        exceptForRent
        flat
        forRent
        petOk
        priceLabel
        purposeSummaryBs
        roomsFrom
        roomsTo
        squareAreaOfMansionFrom
        squareAreaOfMansionTo
        structureSummaries
        tsuboAreaFrom
        tsuboAreaTo
        tsuboLabel
        venderOnly
        __typename
      }
      email
      group
      infoName
      name
      nameRuby
      owner
      paid
      pricingAvailable
      role
      searchInfo
      tel
      trial
      trialEndAt
      updatedAt
      username
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsersBySearchInfoQueryVariables,
  APITypes.ListUsersBySearchInfoQuery
>;
